import React from "react";
import {
    TextField,
    Autocomplete
} from "@mui/material";
import agent from "../../../agent/agent";
import {withStyles} from "@mui/styles";
import clsx from "clsx";

class AutocompleteDriver extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            list: [],

            isLoad: false,

            updateState: 0
        };

        this.refAutocomplete = React.createRef();
    }

    componentDidMount = async () => {
        if (this.props.value) {
            await this.getOptions();
        }
    }

    getOptions = async () => {

        this.setState({ isLoad: true });

        const { expeditorId } = this.props;
        const list = await agent.get(`/users/drivers/${expeditorId}?limit=0`).then((res) => res.data.drivers).catch(() => {
            return []
        });

        this.setState({
            list,
            isLoad: false
        });
    }

    onChange = (value) => {

        if ( this.props.multiple ) {
            const parseValue = [...value].map((item) => {
                return item?.id || item
            })

            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: parseValue || []
                }
            });
        }

        if ( !this.props.multiple ) {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: String(value?.id) || null
                },
            });
        }

    }

    _getOptionLabel = (row) => {
        const options = this.state.list;

        if (typeof row !== 'object') {
            const item = options.find((t) => String(t.id) === String(row));

            if (!item) {
                return ""
            }

            return `${item?.firstName} ${item?.lastName}`
        }

        return `${row?.firstName} ${ row?.lastName }`
    }
    _filterOptions = (list, params) => {
        const inputValue = params?.inputValue || "";

        return list.filter((t) => {

            if (!inputValue) {
                return true
            }

            const nameLowerCase = t.firstName.toLowerCase();
            const inputValueLowerCase = inputValue.toLowerCase();

            return Boolean(nameLowerCase.indexOf(inputValueLowerCase) > -1)

        })
    }

    render() {
        const {
            value,
            name,
            error,
            multiple,
            classes,
        } = this.props;
        const {
            list,
            isLoad
        } = this.state;

        return (
            <>

                <Autocomplete
                    {...this.props}

                    ref={this.refAutocomplete}
                    defaultValue={null}
                    value={value}
                    disablePortal
                    options={list}
                    onChange={(event, value) => this.onChange(value, name)}
                    name={name}
                    variant="outlined"
                    fullWidth
                    disableClearable
                    loading={isLoad}
                    onOpen={this.getOptions}
                    limitTags={1}
                    filterSelectedOptions={Boolean(multiple)}
                    autoComplete={Boolean(multiple)}

                    isOptionEqualToValue={(option, value) => Boolean(String(option.id) === String(value))}

                    getOptionLabel={this._getOptionLabel}
                    filterOptions={this._filterOptions}

                    renderOption={(props, option) => (
                        <li {...props} className={clsx({
                            [classes.listItem]: true,
                            [classes.deactivatedUser]: !option.active,
                        })}>№{option.id} | {option.firstName} {option.lastName} {!option.active && "(деактивирован)"}</li>
                    )}

                    renderInput={(params) => <TextField
                        {...params}
                        label="Водитель"
                        fullWidth
                        error={error}
                        helperText={this.props.helperText}
                    />}
                />

            </>
        );
    }
}

const styles = {
    listItem: {
        padding: "6px 16px",
        fontSize: 14,
        lineHeight: "21px",
        letterSpacing: "0.05px",
        cursor: 'pointer',
        "&:hover": {
            background: "rgba(0, 0, 0, .1)",
        },
    },
    deactivatedUser: {
        textDecoration: "line-through",
        color: "red",
        pointerEvents: "none",
    }
};

export default withStyles(styles)(AutocompleteDriver);
